import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dolgu-ile-meme-diklestirme-nedir/page.tsx");
